export const fun = {
	description: "I love playing volleyball in my free time. I joined the Womens Club Volleyball Team while studying at CMU. I mainly play as a middle blocker (MB) and outside hitter (OH).\nI am also a runway model and my agency is Wilhelmina."
}
